import { Quotes, InstagramLogo, ArrowUpRight } from "@phosphor-icons/react";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { Reveal, Overline } from "./Reveal";
import { TESTIMONIALS, FAQS, BLOG, GALLERY } from "@/data";

const FB = "https://www.facebook.com/share/1AZs3Me9tH/";

export const Testimonials = () => (
  <section id="testimonials" className="relative py-24 md:py-32 bg-[#0d0d0d]">
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <Reveal><Overline>Kind Words</Overline></Reveal>
      <Reveal delay={0.05}>
        <h2 className="font-heading font-black text-3xl md:text-5xl mt-4">Loved by our <span className="gold-text">community</span>.</h2>
      </Reveal>
      <div className="grid md:grid-cols-2 gap-6 mt-14">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.n} delay={(i % 2) * 0.08}>
            <div className="h-full bg-[#141414] border border-white/10 rounded-lg p-8 hover-lift">
              <Quotes size={36} weight="fill" className="text-[#D4AF37]/70" />
              <p className="font-display text-xl md:text-2xl leading-relaxed mt-4 text-zinc-100">&ldquo;{t.q}&rdquo;</p>
              <div className="mt-6 flex items-center gap-3">
                <span className="h-10 w-10 rounded-full bg-[#3B0764] flex items-center justify-center font-heading font-bold text-[#D4AF37]">{t.n[0]}</span>
                <div>
                  <p className="font-heading font-bold">{t.n}</p>
                  <p className="text-sm text-zinc-500">{t.r}</p>
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export const Instagram = () => (
  <section className="relative py-24 md:py-32 bg-[#0A0A0A]">
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <div className="flex flex-col md:flex-row justify-between md:items-end gap-6">
        <div>
          <Reveal><Overline>On The Feed</Overline></Reveal>
          <Reveal delay={0.05}><h2 className="font-heading font-black text-3xl md:text-5xl mt-4">Follow the vibe <span className="gold-text">@epicmemoriesllc</span></h2></Reveal>
        </div>
        <Reveal delay={0.1}>
          <a data-testid="instagram-follow" href={FB} target="_blank" rel="noreferrer"
            className="inline-flex items-center gap-2 bg-[#D4AF37] text-black font-heading font-bold rounded-full px-6 py-3 hover:bg-[#F3E5AB] transition-colors">
            <InstagramLogo size={20} weight="fill" /> Follow Us
          </a>
        </Reveal>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-12">
        {GALLERY.slice(0, 8).map((g, i) => (
          <Reveal key={i} delay={(i % 4) * 0.05}>
            <a href={FB} target="_blank" rel="noreferrer" className="relative block aspect-square overflow-hidden rounded-lg group">
              <img src={g.src} alt="Epic Memories post" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
              <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                <InstagramLogo size={28} weight="fill" className="text-white" />
              </div>
            </a>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export const Blog = () => (
  <section id="blog" className="relative py-24 md:py-32 bg-[#0d0d0d]">
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <Reveal><Overline>The Journal</Overline></Reveal>
      <Reveal delay={0.05}><h2 className="font-heading font-black text-3xl md:text-5xl mt-4">Event tips & <span className="gold-text">inspiration</span>.</h2></Reveal>
      <div className="grid md:grid-cols-3 gap-6 mt-14">
        {BLOG.map((b, i) => (
          <Reveal key={b.t} delay={i * 0.08}>
            <article data-testid={`blog-${i}`} className="group h-full bg-[#141414] border border-white/10 rounded-lg p-7 hover-lift cursor-pointer flex flex-col">
              <span className="text-[#D4AF37] text-xs uppercase tracking-widest font-semibold">{b.c}</span>
              <h3 className="font-heading font-bold text-xl mt-3 leading-snug group-hover:text-[#D4AF37] transition-colors">{b.t}</h3>
              <p className="text-zinc-400 mt-3 leading-relaxed flex-1">{b.d}</p>
              <span className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-white">Read more <ArrowUpRight size={16} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" /></span>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export const FAQ = () => (
  <section id="faq" className="relative py-24 md:py-32 bg-[#0A0A0A]">
    <div className="max-w-3xl mx-auto px-5 md:px-8">
      <Reveal><Overline>FAQ</Overline></Reveal>
      <Reveal delay={0.05}><h2 className="font-heading font-black text-3xl md:text-5xl mt-4">Questions, <span className="gold-text">answered</span>.</h2></Reveal>
      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="mt-10">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`f${i}`} data-testid={`faq-${i}`} className="border-white/10">
              <AccordionTrigger className="font-heading font-bold text-left text-lg hover:text-[#D4AF37] hover:no-underline">{f.q}</AccordionTrigger>
              <AccordionContent className="text-zinc-400 text-base leading-relaxed">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
